import React from "react";
import Chip from "@mui/material/Chip";

const statusMap: Record<string, string> = {
  "not released": "not released",
  "in attesa": "pending",
  not_shippable: "not shippable",
  part_completed: "part. completed",
  ready_to_pick: "ready to pick",
  in_stock: "in stock",
  released: "released",
  approvato: "approved",
  attivo: "active",
  bozza: "draft",
  scaduto: "expired",
  inattivo: "inactive",
  "final d1": "final d1 transit",
  whs_scheduled: "WHS Scheduled",
  whs_booked: "WHS Booked",
  to_do: "to do",
};

const statusColorMap: Record<
  string,
  { color: "success" | "primary" | "warning" | "error" | "default"; bg: string }
> = {
  active: { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  approved: { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  delivered: { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  completed: { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  released: { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  cleared: { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  created: { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  "final h1": { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  "final h4": { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  "final d1 transit": { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  "final a28": { color: "success", bg: "rgba(46, 125, 50, 0.04)" },
  executed: { color: "default", bg: "rgba(189, 189, 189, 0.04)" },
  none: { color: "default", bg: "rgba(189, 189, 189, 0.04)" },
  "part. completed": { color: "primary", bg: "rgba(25, 118, 210, 0.04)" },
  draft: { color: "primary", bg: "rgba(25, 118, 210, 0.04)" },
  "in stock": { color: "primary", bg: "rgba(25, 118, 210, 0.04)" },
  "to do": { color: "primary", bg: "rgba(25, 118, 210, 0.04)" },
  picking: { color: "primary", bg: "rgba(25, 118, 210, 0.04)" },
  "ready to pick": { color: "primary", bg: "rgba(25, 118, 210, 0.04)" },
  pending: { color: "warning", bg: "rgba(239, 108, 0, 0.04)" },
  "WHS Booked": { color: "warning", bg: "rgba(239, 108, 0, 0.04)" },
  partial: { color: "warning", bg: "rgba(239, 108, 0, 0.04)" },
  booked: { color: "warning", bg: "rgba(239, 108, 0, 0.04)" },
  rejected: { color: "error", bg: "rgba(211, 47, 47, 0.04)" },
  "not released": { color: "error", bg: "rgba(211, 47, 47, 0.04)" },
  canceled: { color: "error", bg: "rgba(211, 47, 47, 0.04)" },
  uncleared: { color: "error", bg: "rgba(211, 47, 47, 0.04)" },
  "not shippable": { color: "error", bg: "rgba(211, 47, 47, 0.04)" },
  expired: { color: "default", bg: "rgba(189, 189, 189, 1)" },
  inactive: { color: "default", bg: "rgba(189, 189, 189, 1)" },
};

interface ChipsProps {
  status: string;
  normalize?: boolean;
}

const Chips = ({
  status,
  normalize = false,
  isWhs = false,
}: ChipsProps & { isWhs?: boolean }) => {
  const normalizedInput = status.toLowerCase();
  const mappedStatus = statusMap[normalizedInput] || normalizedInput;
  const finalStatus = mappedStatus.includes("pending")
    ? "pending"
    : mappedStatus;

  const chipData = statusColorMap[finalStatus] || {
    color: "default",
    bg: "rgba(189, 189, 189, 1)",
  };

  const displayLabel = isWhs ? `WHS: ${finalStatus}` : finalStatus;

  return (
    <Chip
      size="small"
      label={!normalize ? displayLabel : displayLabel.toUpperCase()}
      variant="outlined"
      color={chipData.color}
      sx={{
        backgroundColor: chipData.bg,
        textTransform: "capitalize",
        fontWeight: 400,
      }}
    />
  );
};
export default Chips;
